/**
 * Shadow-DOM-Styles als String. Durch Shadow-DOM-Kapselung kollidieren diese
 * NICHT mit dem Makler-Theme (kein !important-Krieg). Branding kommt ueber
 * CSS-Custom-Properties am :host.
 */
export const STYLES = `
:host {
  --wd-primary: #1f2933;     /* Button-Hintergrund, Fokus */
  --wd-btn-text: #ffffff;    /* Button-Textfarbe (eigene Einstellung, kontrastsicher) */
  --wd-text: #1f2933;        /* Grundtextfarbe */
  --wd-accent: #1f2933;      /* Akzent-/Rahmenfarbe (Default = Primaerfarbe) */
  --wd-font: Arial, Helvetica, sans-serif;
  all: initial;
}
*, *::before, *::after { box-sizing: border-box; }

.wd-trigger {
  position: fixed; bottom: 18px; z-index: 2147483645;
  border: 0; border-radius: 8px; padding: 12px 18px; min-height: 44px;
  font: 600 14px/1.2 var(--wd-font); cursor: pointer;
  color: var(--wd-btn-text); background: var(--wd-primary);
  box-shadow: 0 4px 14px rgba(0,0,0,.18);
}
.wd-trigger.wd-left { left: 18px; }
.wd-trigger.wd-right { right: 18px; }
.wd-trigger.wd-inline { position: static; box-shadow: none; }
.wd-trigger:focus-visible { outline: 3px solid #2563eb; outline-offset: 2px; }

.wd-overlay {
  position: fixed; inset: 0; z-index: 2147483646;
  background: rgba(15,23,32,.55);
  display: flex; align-items: center; justify-content: center; padding: 16px;
  font: 400 15px/1.5 var(--wd-font); color: var(--wd-text);
}
.wd-box {
  position: relative; width: 100%; max-width: 600px; max-height: 90vh;
  overflow: auto; background: #fff; color: var(--wd-text);
  border-radius: 12px; box-shadow: 0 20px 60px rgba(0,0,0,.35);
  border-top: 4px solid var(--wd-accent);
}
.wd-inner { padding: 24px; }
.wd-close {
  position: absolute; top: 8px; right: 10px; z-index: 2; border: 0;
  background: transparent; font-size: 26px; line-height: 1; cursor: pointer;
  color: #52606d; width: 44px; height: 44px; border-radius: 8px;
}
.wd-close:focus-visible { outline: 3px solid #2563eb; outline-offset: 2px; }

.wd-logo { max-height: 48px; max-width: 220px; margin-bottom: 12px; display: block; }
h1.wd-h1 { font: 700 20px/1.3 var(--wd-font); margin: 0 0 4px; }
.wd-sub { color: #5b6770; margin: 0 0 16px; font-size: 14px; }
label { display: block; font-size: 13px; font-weight: 600; margin: 14px 0 4px; }
input, textarea {
  width: 100%; padding: 10px 12px; min-height: 44px;
  border: 1px solid #cbd2d9; border-radius: 6px; font: inherit; font-size: 16px;
  color: var(--wd-text); background: #fff;
}
textarea { min-height: 90px; resize: vertical; }
input:focus, textarea:focus {
  outline: 2px solid var(--wd-primary); outline-offset: 1px; border-color: var(--wd-primary);
}
input[aria-invalid="true"], textarea[aria-invalid="true"] { border-color: #b91c1c; }

.wd-req { color: #b91c1c; }
.wd-err { color: #b91c1c; font-size: 13px; margin: 4px 0 0; }
.wd-hint {
  background: #eff6ff; border: 1px solid #bfdbfe; color: #1e3a8a;
  padding: 10px 12px; border-radius: 6px; font-size: 13px; margin: 8px 0 16px;
}
.wd-errbox {
  background: #fef2f2; border: 1px solid #fecaca; color: #991b1b;
  padding: 12px; border-radius: 6px; font-size: 14px; margin-bottom: 16px;
}
fieldset.wd-ident { border: 1px solid #e4e7eb; border-radius: 8px; padding: 8px 14px 14px; margin: 16px 0; }
legend { font-size: 13px; font-weight: 600; padding: 0 6px; }
details.wd-belehrung { margin: 0 0 16px; border: 1px solid #e4e7eb; border-radius: 6px; padding: 8px 12px; }
details.wd-belehrung summary { cursor: pointer; font-weight: 600; font-size: 13px; color: var(--wd-primary); }
.wd-belehrung-body { margin-top: 10px; font-size: 13px; color: #444; line-height: 1.55; white-space: pre-wrap; }
/* Klar getrennte Abschnitte in der Klappbox: Belehrung / Muster-Widerrufsformular / Anbieter. */
.wd-legal-sec { margin: 14px 0 0; }
.wd-legal-sec:first-child { margin-top: 10px; }
.wd-legal-h { font: 700 13px/1.3 var(--wd-font); margin: 0; color: var(--wd-text); }
.wd-legal-sec .wd-belehrung-body { margin-top: 4px; }
.wd-muster { border: 1px solid #e4e7eb; border-radius: 6px; padding: 8px 12px; background: #f8fafc; }
.wd-muster .wd-belehrung-body { color: #555; }
.wd-contact { font-size: 13px; line-height: 1.5; margin-top: 4px; }

.wd-actions { margin-top: 20px; display: flex; gap: 8px; flex-wrap: wrap; }
.wd-btn {
  border: 0; border-radius: 6px; padding: 12px 22px; min-height: 44px;
  font: 600 15px/1.2 var(--wd-font); cursor: pointer;
  color: var(--wd-btn-text); background: var(--wd-primary);
}
.wd-btn-secondary { background: #e4e7eb; color: #1f2933; }
.wd-btn:focus-visible, .wd-btn-secondary:focus-visible { outline: 3px solid #2563eb; outline-offset: 2px; }

.wd-summary { border: 1px solid #e4e7eb; border-radius: 8px; padding: 4px 16px; margin: 16px 0; }
.wd-row { display: flex; gap: 12px; padding: 8px 0; border-bottom: 1px solid #f1f3f5; font-size: 14px; }
.wd-row:last-child { border-bottom: 0; }
.wd-row .wd-k { color: #5b6770; min-width: 160px; }
.wd-ok { background: #f0fdf4; border: 1px solid #bbf7d0; color: #166534; padding: 16px; border-radius: 8px; }
.wd-loading { padding: 24px; text-align: center; color: #5b6770; }

/* Honeypot: fuer Menschen unsichtbar, fuer Bots vorhanden. */
.wd-hp { position: absolute !important; left: -9999px !important; top: -9999px !important; height: 0; overflow: hidden; }

@media (max-width: 480px) {
  .wd-trigger { left: 12px; right: 12px; text-align: center; }
  .wd-trigger.wd-right { left: 12px; }
}
`;
